module.exports = __webpack_public_path__ + "media/Andréa_Zarraluqui.5e031826.mp4";